module.exports = __webpack_public_path__ + "img/1f9c4.e19fcf5.svg";